import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useImageControls } from './common/useImageControls';
import { ImageControls } from './common/ImageControls';
import { Recovery } from './common/Recovery';
import { FileExclamationOutlined } from '@ant-design/icons';
import { TGA } from './common/tga';
import { Buffer } from 'buffer';
import { ViewerPropertiesComplete } from '../model';

export const MediaTGA: React.FC<ViewerPropertiesComplete> = ({ src, attachEventsToDocument }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [tga, setTGA] = useState<TGA | 'error' | 'recovering'>('recovering');
  const rd = useMemo(
    () => (tga instanceof TGA ? { width: tga.header.width, height: tga.header.height } : undefined),
    [tga],
  );
  const imageController = useImageControls(
    tga instanceof TGA,
    containerRef,
    attachEventsToDocument,
    rd,
  );

  useEffect(() => {
    setTGA('recovering');
  }, [src]);

  // Не показываем размер картинки: https://jira.my.games/browse/MYUA-4831
  // useEffect(() => {
  //   if (tga instanceof TGA) {
  //     onMetadataAvailable({ height: tga.header.height, width: tga.header.width });
  //   }
  // }, [tga, onMetadataAvailable]);

  useEffect(() => {
    const controller = new AbortController();
    const f = async () => {
      const r = await fetch(src, { signal: controller.signal });
      // const reader = r.body?.getReader();
      // const cl = r.headers.get('Content-Length');
      // const contentLength = cl !== null ? parseInt(cl, 10) : null;
      if (r.ok) {
        const body = await r.blob();
        const AB = await body.arrayBuffer();
        const _tga = new TGA(Buffer.from(AB));
        setTGA(_tga);
      } else {
        setTGA('error');
      }
    };

    if (tga === 'recovering') {
      void f();
    }

    return () => {
      controller.abort();
    };
  }, [src, tga]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (canvas === null || container === null || !(tga instanceof TGA)) return;
    canvas.width = tga.header.width;
    canvas.height = tga.header.height;
    const ctx = canvas.getContext('2d');
    if (ctx === null) return;

    const id = new ImageData(
      Uint8ClampedArray.from(tga.pixels),
      tga.header.width,
      tga.header.height,
    );

    ctx?.putImageData(id, 0, 0);
  }, [tga]);

  const body =
    tga instanceof TGA ? (
      <>
        <canvas
          width={tga.header.width}
          height={tga.header.height}
          ref={canvasRef}
          onMouseDown={imageController.dragOnMouseDown}
          style={{
            transform: imageController.cssTransform,
          }}
        />
        <ImageControls controller={imageController} />
      </>
    ) : tga === 'error' ? (
      <>
        <div style={{ fontSize: 80 }}>
          <FileExclamationOutlined />
        </div>
        <Recovery onRecovery={() => setTGA('recovering')} />
      </>
    ) : (
      <progress max="100" />
    );
  return (
    <div className="gen-file-viewer__image-container gen-file-viewer__container" ref={containerRef}>
      {body}
    </div>
  );
};
